<template>
    <div>

        <h5 class="mt-3 ml-3 activeTriggerHeader"><u>HIT TRIGGERS {{hit}}</u></h5>
        <TriggerHitAlert :reportTradingGroupId="reportTradingGroupId" />
        <h5 class="ml-3 dueLiveTriggerHeader"><u>TRIGGERS STATUS {{status}}</u></h5>
        <StatusAlert :reportTradingGroupId="reportTradingGroupId" />
        <h5 class="ml-3 expiredTriggerHeader"><u>DEFAULT DEADLINES {{deadline}}</u></h5>
    <DeadlineAlert :reportTradingGroupId="reportTradingGroupId" />
</div>
</template>
<script>
    import TriggerHitAlert from "../../triggerAlerts/TriggerHitAlert.vue";
    import StatusAlert from "../../triggerAlerts/StatusAlert.vue";
    import DeadlineAlert from "../../triggerAlerts/DeadlineAlert.vue";
    import store from '../../../store';
    import urls from '../../../common/urls';
    import apis from '../../../common/network';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    export default {
        name: "",
        data() {
            return {
                store: store,
                reportTradingGroupId: store.state.reportTradingGroupId,
                deadline: "",
                status: "",
                hit: ""
            };
        },
        components: {
            TriggerHitAlert,
            StatusAlert,
            DeadlineAlert
        },
        computed: {},
        mounted: function () {
            const spinners = document.querySelectorAll(".e-grid .e-spinner-pane:not(#mainSpinner)");
            spinners.forEach(spinner => {

                spinner.style.display = 'none';

            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('mainSpinner'));
        },
        methods: {
            fetchData(id) {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCountsATG?tradingGroupId=${id}`).then(it => {
                    this.deadline = it.data.deadline;
                    this.status = it.data.status;
                    this.hit = it.data.hit;
                    hideSpinner(document.getElementById('mainSpinner'));

                }
                ).catch(
                    response => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },
        },
        created: function () {
            this.fetchData(store.state.reportTradingGroupId);
        },
    };
</script>
<style>

    .activeTriggerHeader {
        text-align: left;
        text-transform: uppercase;
        color: #001c55;
    }

    .dueLiveTriggerHeader {
        text-align: left;
        text-transform: uppercase;
        color: #7FB7BE;
    }

    .expiredTriggerHeader {
        text-align: left;
        text-transform: uppercase;
        color: #d9843b;
    }
</style>